import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { getCommandsEnCours } from '@/api/commandes.api'
import { APP_NAME, validateCommandsPageSearchParams } from '@/lib/utils'
import CommandsEnCours from '@/features/commands/components/extensions/commands-en-cours'

export const Route = createFileRoute('/_authenticated/commands-en-cours/')({
  component: () => {
    const { t } = useTranslation()
    return (
      <CommandsEnCours
        queryExtension={{
          title: t('sidebar.commandes-en-cours'),
          querykey: 'en-cours',
          queryFn: getCommandsEnCours,
        }}
      />
    )
  },
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Commandes en cours`,
      },
    ],
  }),
  validateSearch: validateCommandsPageSearchParams,
})
